class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    document.body.classList.add('is-presenting-modal');
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification.classList.contains('active')) return;

    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);

    const cleanup = () => {
      clearTimeout(fallbackId);
      this.notification.removeEventListener('transitionend', onTransitionEnd);
      this.notification.classList.remove('animate');
      document.body.classList.remove('is-presenting-modal');
    };

    const onTransitionEnd = (event) => {
      if (event.target !== this.notification) return;
      cleanup();
    };

    const fallbackId = setTimeout(cleanup, 700);
    this.notification.addEventListener('transitionend', onTransitionEnd);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key || (parsedState.items && parsedState.items[0] && parsedState.items[0].key);
      if (!this.cartItemKey) return;
      this.getSectionsToRender().forEach((section => {
        const target = document.getElementById(section.id);
        if (!target) return;
        const html = parsedState.sections[section.id];
        if (!html) return;
        const inner = this.getSectionInnerHTML(html, section.selector);
        if (inner !== null && inner !== undefined) target.innerHTML = inner;
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const node = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return node ? node.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
